module.exports = __webpack_public_path__ + "img/norway-digestive-diseases-female.82b0abbf.png";